import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class IssueDayOutOfRangeError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.sale.validation.issue-day.out-of-range');
    }
}
